// Dependencies
import  React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { getTypePay } from '../../reducers/TypePayment';
import Principal from './Principal';
import Steps from './Steps.js';

const Content = () => {
    const reduxType = useSelector(getTypePay);
    const [viewPrincipal, setViewPrincipal] = useState(true);

    useEffect(() => {
        if(reduxType === 0){
            setViewPrincipal(true);
        }else{
            setViewPrincipal(false);
        }
    }, [reduxType])

    return (
        <>
            {(viewPrincipal) ? 
                <Principal/>
                : <Steps/>
            }
        </>
    );
}

export default Content;